import styles from './WizardSpinner.module.css'

type WizardSpinnerProps = {
  message?: string
}

function WizardSpinner({ message = 'Loading...' }: WizardSpinnerProps) {
  return (
    <div className={styles.container}>
      <div className={styles.spinner} />
      <p className={styles.message}>{message}</p>
    </div>
  )
}

export { WizardSpinner }
